import { IAbscenceTypeRepository } from "domain/contracts/abscence-type.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { AbscenceType } from "domain/entities/abscence-type";
import { AbscenceTypeInputFilter } from "domain/models/abscence-type-input-filter";

class AbscenceTypeRepository implements IAbscenceTypeRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/abscenceType/${id}`);
    return response.data;
  }

  async create(input: AbscenceType): Promise<Message<AbscenceType>> {
    const response = await httpClient.post(`/abscenceType`, { data: input });
    return response.data;
  }

  async update(input: AbscenceType): Promise<Message<boolean>> {
    const response = await httpClient.put(`/abscenceType/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(
    filter: AbscenceTypeInputFilter
  ): Promise<Message<AbscenceType[]>> {
    const response = await httpClient.get(`/abscenceType`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<AbscenceType>> {
    const response = await httpClient.get(`/abscenceType/${id}`);
    return response.data;
  }
}

export default new AbscenceTypeRepository();
